import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { DashboardQueryParamValues } from 'core/queryParams/useDashboardParams'
import { TraceRequest, TraceResponse } from './trace.types'
import { getTrace } from './trace'

const signedUrlQueryKeys = {
  base: ['trace'] as const,
  detail: ({ suite, project, runId, traceFile }: DashboardQueryParamValues) => [
    'trace',
    suite,
    project,
    runId,
    traceFile,
  ],
}

export const useGetSignedTrace = (
  request: DashboardQueryParamValues
): UseQueryResult<TraceResponse> => {
  return useQuery<TraceResponse>({
    queryKey: signedUrlQueryKeys.detail(request),
    queryFn: () => getTrace(request as TraceRequest),
    enabled:
      !!request.suite &&
      !!request.project &&
      !!request.runId &&
      !!request.traceFile,
  })
}
